import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { scrollToPageTarget } from './NavLinkScroll'

/** Scrolls to hash after route changes (direct links, refresh, back/forward). */
export default function HashScrollOnNav() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash && hash.length > 1) {
      scrollToPageTarget(hash.slice(1))
    }
  }, [pathname, hash])

  return null
}
